import type { ContactsOfferCompany } from "@containers/Hermes/types";

const normalise = (text: string) => text.toLowerCase().replace(/\s+/g, " ").trim();

/**
 * The company each row of an answer's table stands for, by row index: the offer
 * company whose name (standardised or display) is one of the row's cells. Null for
 * a row that names no offered company.
 */
export function rowCompanies(rows: string[][], companies: ContactsOfferCompany[]): (ContactsOfferCompany | null)[] {
  const byName = new Map<string, ContactsOfferCompany>();
  for (const company of companies) {
    for (const name of [company.display, company.name]) if (name) byName.set(normalise(name), company);
  }
  return rows.map((cells) => {
    for (const cell of cells) {
      const found = byName.get(normalise(cell));
      if (found) return found;
    }
    return null;
  });
}

/**
 * The offer's companies narrowed to the selected rows. The offer also lists a
 * match-only alias entry per company (same id, another name), so every entry
 * sharing a selected company's id is kept.
 */
export function companiesOfRows(selected: Set<number>, perRow: (ContactsOfferCompany | null)[], companies: ContactsOfferCompany[]): ContactsOfferCompany[] {
  const ids = new Set<string>();
  for (const index of selected) {
    const company = perRow[index];
    if (company) ids.add(company.master_id || company.company_id || company.name);
  }
  return companies.filter((company) => ids.has(company.master_id || company.company_id || company.name));
}
